export default __webpack_public_path__ + "static/media/SAIA.3b5b91c6.png";